import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';

export const isLoadingSlice = (state: AppState) => state.topography.loading;
export const paddocksSlice = (state: AppState) => state.topography.paddocks;

export const isLoading = createSelector(isLoadingSlice, (state) => state);

export const paddocks = createSelector(paddocksSlice, (state) => state);
